import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"],
  _excluded2 = ["children", "className", "direction", "responsive"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { createContext, useContext } from 'react';
import classNames from 'classnames';
import { useIsWithinBreakpoints } from '../../../services/breakpoint';
import { useEuiMemoizedStyles } from '../../../services';
import { EuiPanel, _canRenderHighContrastBorder } from '../panel';
import { euiSplitPanelOuterStyles, euiSplitPanelInnerStyles } from './split_panel.styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Consumed via `EuiSplitPanel.Inner`.
 * Extends most `EuiPanelProps`.
 */
export var _EuiSplitPanelInner = function _EuiSplitPanelInner(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var borderDirection = useContext(SplitPanelInnerBorderDirection);
  var classes = classNames('euiSplitPanel__inner', className);
  var styles = useEuiMemoizedStyles(euiSplitPanelInnerStyles);
  var cssStyles = [styles.euiSplitPanelInner, borderDirection && styles.highContrastBorders[borderDirection]];
  var panelProps = {
    hasShadow: false,
    color: 'transparent',
    borderRadius: 'none',
    hasBorder: false
  };
  return ___EmotionJSX(EuiPanel, _extends({
    element: "div",
    className: classes,
    css: cssStyles
  }, panelProps, rest), children);
};
/**
 * Consumed via `EuiSplitPanel.Outer`.
 * Extends most `EuiPanelProps`.
 */
export var _EuiSplitPanelOuter = function _EuiSplitPanelOuter(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'column' : _ref2$direction,
    _ref2$responsive = _ref2.responsive,
    responsive = _ref2$responsive === void 0 ? ['xs', 's'] : _ref2$responsive,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var isResponsive = useIsWithinBreakpoints(responsive, !!responsive);
  var responsiveDirection = direction === 'row' && !isResponsive ? 'row' : 'column';
  var innerBorderDirection = _canRenderHighContrastBorder(_objectSpread({}, rest)) ? responsiveDirection : undefined;
  var styles = euiSplitPanelOuterStyles;
  var cssStyles = [styles.euiSplitPanelOuter, styles[responsiveDirection]];
  var classes = classNames('euiSplitPanel', className);
  return ___EmotionJSX(EuiPanel, _extends({
    paddingSize: "none",
    grow: false,
    className: classes,
    css: cssStyles
  }, rest), ___EmotionJSX(SplitPanelInnerBorderDirection.Provider, {
    value: innerBorderDirection
  }, children));
};
var SplitPanelInnerBorderDirection = /*#__PURE__*/createContext(undefined);
export var EuiSplitPanel = {
  Outer: _EuiSplitPanelOuter,
  Inner: _EuiSplitPanelInner
};